import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import Box from '@mui/material/Box';

import type { Dispatch, SetStateAction } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { AudienceForm } from '../../types';
import { GroupList } from './components/groups/GroupList';
import type { DrawerState } from './drawerTypes';

export type ExcludeCriteriaProps = {
  setDrawerState: Dispatch<SetStateAction<DrawerState>>;
  isEdit: boolean;
  isCreate?: boolean;
  isCreateFromTemplate?: boolean;
  onRemove: () => void;
  hasError?: boolean;
  errorMessage?: string;
  onMarketUnionCoerced?: () => void;
  isListInteractionDisabled?: boolean;
  listInteractionDisabledMessage?: string;
};

export const ExcludeCriteria = ({
  setDrawerState,
  onRemove,
  errorMessage,
  isEdit,
  isCreate,
  isCreateFromTemplate,
  onMarketUnionCoerced,
  isListInteractionDisabled = false,
  listInteractionDisabledMessage,
}: ExcludeCriteriaProps) => {
  const { t } = useTranslation();

  const { fields, append, update, remove } = useFieldArray<AudienceForm, 'normalized_definition.excludes.groups'>({
    name: 'normalized_definition.excludes.groups',
  });

  return (
    <Box data-test="exclude-criteria-container" className={errorMessage ? 'criteria-error' : undefined}>
      <GroupList
        icon={<BlockRoundedIcon fontSize="small" color="error" />}
        title={t('Excludes')}
        isEdit={isEdit}
        isCreate={isCreate}
        isCreateFromTemplate={isCreateFromTemplate}
        fieldName="normalized_definition.excludes"
        fields={fields}
        update={update}
        remove={remove}
        append={append}
        setDrawerState={setDrawerState}
        onExclusionsRemoved={onRemove}
        errorMessage={errorMessage}
        onMarketUnionCoerced={onMarketUnionCoerced}
        isListInteractionDisabled={isListInteractionDisabled}
        listInteractionDisabledMessage={listInteractionDisabledMessage}
      />
    </Box>
  );
};
